export default "__VITE_ASSET__Cxt5Dkjg__"